export default {
    current: {
        phone: {
            description: '{userName} est déjà en appel.',
        },
        sms: {
            description: '{userName} compose déjà un SMS.',
        },
        email: {
            description: '{userName} compose déjà un courriel.',
        },
        video: {
            description: '{userName} est déjà en vidéoconférence.',
        },
    },
    recent: {
        phone: {
            description: '{userName} a appelé {timeAgo}.',
        },
        sms: {
            description: '{userName} a envoyé un SMS {timeAgo}.',
        },
        email: {
            description: '{userName} a envoyé un courriel {timeAgo}.',
        },
    },
};
